<!-- 活动管理-活动管理 -->

<script setup></script>

<template>
  <div id="activity">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
      <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#activity {
  height: 100%;
}
</style>
